var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleAvatarPatientTicketMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "#FDD158"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1432_10050",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1432_10050)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1432_10050)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.389,
    cy: 47.584,
    rx: 19.0751,
    ry: 40.1744,
    fill: "#242446"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3554,
    cy: 22.7381,
    rx: 6.66936,
    ry: 4.53596,
    fill: "#007C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6784 95.9876C79.6784 84.0408 69.9936 74.356 58.0468 74.356H38.9529C27.0061 74.356 17.3213 84.0408 17.3213 95.9876V104.576C26.336 110.309 37.0255 113.643 48.4999 113.643C59.9743 113.643 70.6637 110.309 79.6784 104.576V95.9876Z",
    fill: "#CE569E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3129 64.1396V70.4779C55.3129 74.6624 52.2291 78.0546 48.425 78.0546H48.2859C44.4818 78.0546 41.3979 74.6624 41.3979 70.4779V64.1396",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3979 68.6963C43.4888 69.5998 45.7748 70.1059 48.175 70.1059H48.5358C50.936 70.1059 53.222 69.5998 55.3129 68.6963V65.8223H41.3979V68.6963Z",
    fill: "#F5BC8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.643 48.1816H30.7305C33.1213 48.1816 35.0595 46.2434 35.0595 43.8525V43.7651C35.0595 41.3742 33.1213 39.436 30.7305 39.436H30.643C28.2521 39.436 26.314 41.3742 26.314 43.7651V43.8525C26.314 46.2434 28.2521 48.1816 30.643 48.1816ZM65.9809 48.1816H66.0683C68.4592 48.1816 70.3974 46.2434 70.3974 43.8525V43.7651C70.3974 41.3742 68.4592 39.436 66.0683 39.436H65.9809C63.59 39.436 61.6518 41.3742 61.6518 43.7651V43.8525C61.6518 46.2434 63.59 48.1816 65.9809 48.1816Z",
    fill: "#F5BD8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5358 23.7144H48.1749C38.3087 23.7144 30.3105 32.1327 30.3105 42.5173V48.5988C30.3105 58.9833 38.3087 67.4017 48.1749 67.4017H48.5358C58.402 67.4017 66.4001 58.9833 66.4001 48.5988V42.5173C66.4001 32.1327 58.402 23.7144 48.5358 23.7144Z",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7092,
    cy: 46.3845,
    rx: 2.36346,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8791,
    cy: 46.3845,
    rx: 2.36347,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3873 61.3385H48.3092C46.1752 61.3385 44.4453 59.6085 44.4453 57.4746V57.4355H52.2511V57.4746C52.2511 59.6085 50.5212 61.3385 48.3873 61.3385Z",
    fill: "#F3B28E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0683 39.4361C57.8537 42.0396 51.447 28.3927 47.3824 35.0587C45.024 38.9265 36.0159 39.7767 29.9854 39.0364L29.9854 38.2887C29.9854 28.1951 38.1678 20.0127 48.2614 20.0127H48.6306C57.8816 20.0127 65.915 26.3848 67.1916 35.2197C67.4061 36.7041 66.9775 38.216 66.0813 39.4187L66.0683 39.4361Z",
    fill: "#242446"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1432_10050",
    x: 13.3213,
    y: 7.40967,
    width: 70.3569,
    height: 114.233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1432_10050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1432_10050",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleAvatarPatientTicketMessage);
export default __webpack_public_path__ + "static/media/female-avatar-patient-ticket-message.ab75d5b38c39de8c9fda9390336208a8.svg";
export { ForwardRef as ReactComponent };